import React from 'react'
import { Card, Col, Form, InputNumber, Row, Space } from 'components/common'

export const UsageLimitCard = ({ usageLimit }) => {
  return (
    <>
      <Card>
        <Row>
          <Space direction="vertical">
            <Col span={24}>
              <Form.Item
                name={'usageLimit'}
                label="最大可能回数"
                labelCol={{ span: 24 }}
                initialValue={usageLimit}
                rules={[
                  {
                    required: true,
                    message: 'ディスカウントの最大可能回数を入力してください',
                  },
                ]}
              >
                <InputNumber min={1} max={1000} keyboard={false} />
              </Form.Item>
            </Col>
          </Space>
        </Row>
      </Card>
    </>
  )
}
